import LegalPage from "@/components/site/LegalPage";

export default function Privacy() {
    return (
        <LegalPage
            title="Privacy Policy"
            lastUpdated="December 2026"
            testId="privacy-page"
        >
            <p>
                CHIGLE ("we", "our", "us") respects your privacy. This Privacy Policy
                explains how we collect, use, and protect the information you share with
                us when you visit chigle.co or join our early-access waitlist.
            </p>

            <h2 className="font-display text-3xl text-primary mt-10 mb-3">
                Information we collect
            </h2>
            <p>
                When you submit our waitlist form, we collect your name, email, phone
                number, city, role (Generator / Collector / Processor), and the
                role-specific details you provide (such as organisation, waste type,
                vehicle, areas covered, or processing capacity). We collect basic
                anonymised analytics about how visitors use the site.
            </p>

            <h2 className="font-display text-3xl text-primary mt-10 mb-3">
                How we use it
            </h2>
            <ul className="list-disc pl-6 space-y-2">
                <li>To onboard you into the CHIGLE early-access programme.</li>
                <li>To contact you about pickups, demos, pilots, or product updates.</li>
                <li>To improve our product, routing models, and supply matching.</li>
            </ul>
            <p>
                We will never sell your personal information. We do not share your data
                with third parties except service providers strictly necessary to operate
                the platform (e.g. email delivery, secure database hosting), all bound
                by confidentiality.
            </p>

            <h2 className="font-display text-3xl text-primary mt-10 mb-3">
                Your choices
            </h2>
            <p>
                You may request access, correction, or deletion of your information at
                any time by writing to{" "}
                <a
                    className="text-accent underline-offset-4 hover:underline"
                    href="mailto:teamchigle@gmail.com"
                >
                    teamchigle@gmail.com
                </a>
                . You may unsubscribe from communications by replying to any message we
                send you.
            </p>

            <h2 className="font-display text-3xl text-primary mt-10 mb-3">Security</h2>
            <p>
                We store waitlist data in encrypted databases and transmit it over HTTPS.
                Access is restricted to authorised CHIGLE team members.
            </p>

            <h2 className="font-display text-3xl text-primary mt-10 mb-3">Contact</h2>
            <p>
                Questions about this policy? Email{" "}
                <a
                    className="text-accent underline-offset-4 hover:underline"
                    href="mailto:teamchigle@gmail.com"
                >
                    teamchigle@gmail.com
                </a>
                .
            </p>
        </LegalPage>
    );
}
